import {TranslateKey} from '../locale/type';

export const USER_STATE_NAME = 'user';

export const EMAIL_REGEX_VALIDATION_MESSAGE_KEY = 'email_alert_correct_address';

export const EMAIL_LOGIN_PLACEHOLDER_KEY_MAP: {
  [key: string]: TranslateKey;
} = {
  email: 'email_inputbox_guide',
  password: 'email_password_inputbox_guide',
};

export const EMAIL_SIGNUP_CODE_VALID_TIME = 1000 * 60 * 5;
export const EMAIL_SIGNUP_CODE_LENGTH = 6;

export const EMAIL_PASSWORD_MIN_LENGTH = 8;
export const EMAIL_PASSWORD_MIN_VALIDATION_MESSAGE_KEY =
  'email_alert_correct_password';
export const EMAIL_PASSWORD_EQUAL_VALIDATION_MESSAGE_KEY =
  'email_password_reset_complete_alert_recheck_inconsistency';

export const VERIFY_PARENT_EMAIL_VALID_TIME = 1000 * 60 * 60;
